export default __webpack_public_path__ + "assets/images/777144caba628dbd67af5a6af3270bb3.png";